<template>
  <div>
    <list ref="recordlist" v-show="formStatus == 'list'" :buttonPriviledgeList="buttonPriviledgeList" @viewDetailCallback="handleView"></list>
    <detail v-if="formStatus == 'detail'" :buttonPriviledgeList="buttonPriviledgeList" :id="checkId" @back="back"></detail>
  </div>
</template>
<script>
import {default as PermissionApi} from "@/api/smp/auth/Permission.js";

import List from "@/views/pd/maintenance/order-detail/List";
import Detail from "@/views/pd/maintenance/order-detail/Detail";

export default {
  name: "Pd-Manager-Order-Detail",
  components: {List, Detail},
  props: {
    page: {
      type: Object,
      default: null
    }
  },
  mounted() {
    this.getButtonPriviledge()
  },
  data() {
    return {
      formStatus: 'list',
      checkId: null,
      buttonPriviledgeList: []
    }
  },
  methods: {
    getButtonPriviledge() {
      console.log('this.page', this.page)
      let menuId = this.page.id
      let me = this
      PermissionApi.queryButtonPriviledge(menuId, null).then(resp => {
        PermissionApi.handleResponse(resp, me, function (data) {
          me.buttonPriviledgeList = data.buttonPriviledges
          console.log('buttonPriviledgeList', me.buttonPriviledgeList)
        })
      })
    },
    handleView(data) {
      this.formStatus = data.formStatus;
      this.checkId = data.checkId;
    },
    back() {
      this.formStatus = 'list';
      this.$refs.recordlist.getDataFromApi();
    }
  }
}
</script>

<style scoped>

</style>